import ReusableMenu from "../menu/ReusableMenu";
import loader from "../../assets/button-loader.svg";
import downArrow from "../../assets/down-arrow.svg";
import rightChev from "../../assets/rightchev.svg";
import { Tooltip } from "@mui/material";
import { dateSimplewithComma } from "../../utils/constants";

import React, { useState } from "react";
const ManageWalletsTable = ({
  allWallets = [],
  prevPage,
  nextPage,
  paginate,
  currentPage,
  indexOfFirstItem,
  indexOfLastItem,
  itemsPerPage,
  isFetching,
  handleItemsPerPageChange,
  totalCount,
  getAllWallets,
  getSubscribedWallets,
  getUnsubscribedWallets,
}) => {
  const [filter, setFilter] = useState("all");

  // For unsubscribed, we still filter locally, but for 'all' and 'subscribed', use API
  const getFilteredWallets = () => {
    if (filter === "unsubscribed") return allWallets.filter(w => !w.isSubscribed);
    return allWallets;
  };
  const filteredWallets = getFilteredWallets();
  return (
    <>
      {/* Filter Tabs */}
      <div className="flex items-center bg-[#282828] rounded-full px-2 py-1 w-fit mb-4">
        <button
          className={`px-6 py-2 rounded-full font-medium text-sm focus:outline-none transition-all ${filter === 'all' ? 'text-white' : 'text-[#bcbcbc]'}`}
          style={filter === 'all' ? {background: 'linear-gradient(90deg, #45B2FF 0%, #6552FE 100%)'} : {background: 'transparent'}}
          onClick={() => {
            setFilter('all');
            getAllWallets && getAllWallets();
          }}
        >
          All
        </button>
        <button
          className={`px-6 py-2 rounded-full font-medium text-sm focus:outline-none transition-all ${filter === 'subscribed' ? 'text-white' : 'text-[#bcbcbc]'}`}
          style={filter === 'subscribed' ? {background: 'linear-gradient(90deg, #45B2FF 0%, #6552FE 100%)'} : {background: 'transparent'}}
          onClick={() => {
            setFilter('subscribed');
            getSubscribedWallets && getSubscribedWallets();
          }}
        >
          Subscribed
        </button>
        <button
          className={`px-6 py-2 rounded-full font-medium text-sm focus:outline-none transition-all ${filter === 'unsubscribed' ? 'text-white' : 'text-[#bcbcbc]'}`}
          style={filter === 'unsubscribed' ? {background: 'linear-gradient(90deg, #45B2FF 0%, #6552FE 100%)'} : {background: 'transparent'}}
          onClick={() => {
            setFilter('unsubscribed');
            getUnsubscribedWallets && getUnsubscribedWallets();
          }}
        >
          Unsubscribed
        </button>
      </div>
      <div className="rounded-xl bg-[#1E1E1E] shadow-lg border border-[#313D4F]">
        <div className="inline-block w-full rounded-lg overflow-auto">
          <div
            className={`${!isFetching ? "h-[60vh] " : ""} ${
              allWallets.length > 5 && !isFetching ? " h-[70vh]" : ""
            } overflow-clip rounded-xl flex flex-col`}>
            <table className="w-full table-fixed border-separate border-spacing-0">
              <thead className="text-[#D9D9D9] bg-[#353535] sticky top-0 z-10">
                <tr className="border-b border-[#313D4F]">
                  <th className="w-[35%] px-4 py-4 text-left text-sm font-semibold tracking-wider">Wallet ID</th>
                  <th className="w-[30%] px-4 py-4 text-left text-sm font-semibold tracking-wider">Email Address</th>
                  <th className="w-[20%] px-4 py-4 text-center text-sm font-semibold tracking-wider">Created At</th>
                  <th className="w-[15%] px-4 py-4 text-center text-sm font-semibold tracking-wider">Subscription</th>
                </tr>
              </thead>
            </table>
            {!isFetching && (
              <>
                {filteredWallets?.length > 0 && (
                  <div className="flex-1 overflow-y-auto">
                    <table className="w-full table-fixed">
                      <tbody className="text-[#F3F3F3] bg-[#1E1E1E] divide-y divide-[#313D4F]">
                        {filteredWallets?.map((item, ind) => (
                          <tr key={`${item?.id}=${ind}`} className="hover:bg-[#2A2A2A] transition-colors">
                            <td className="w-[35%] px-4 py-4">
                              <Tooltip
                                placement="top-start"
                                className="cursor-pointer"
                                componentsProps={{
                                  tooltip: {
                                    sx: {
                                      border: "1px solid #313D4F",
                                      fontSize: "12px",
                                      bgcolor: "#1E1E1E",
                                      "& .MuiTooltip-arrow": {
                                        color: "#313D4F",
                                      },
                                    },
                                  },
                                }}
                                arrow
                                title={item?.id?.length > 30 ? item?.id : null}>
                                <p className="text-sm font-medium truncate">
                                  {item?.id?.length > 30 ? `${item?.id?.slice(0, 30)}...` : item?.id}
                                </p>
                              </Tooltip>
                            </td>
                            <td className="w-[30%] px-4 py-4">
                              <p className="text-sm truncate">{item?.email_address}</p>
                            </td>
                            <td className="w-[20%] px-4 py-4 text-center">
                              <p className="text-sm ml-5">{dateSimplewithComma(item?.created_at)}</p>
                            </td>
                            <td className="w-[15%] px-4 py-4 text-center">
                              <span className={`inline-flex items-center justify-center px-3 py-1 rounded-full text-xs font-medium ml-5 ${
                                item?.isSubscribed ? 'bg-green-500 text-white' : 'bg-red-500 text-white'
                              }`}>
                                {item?.isSubscribed ? 'Subscribed' : 'Unsubscribed'}
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </>
            )}
          </div>
          {allWallets?.length <= 0 && !isFetching && (
            <div className="flex text-[#D9D9D9] min-h-[25vh] justify-center items-center">
              No Data Found
            </div>
          )}
          {isFetching && (
            <div className="flex min-h-[50vh] justify-center items-center">
              <img src={loader} alt="ok" className="w-10 h-10 " />
            </div>
          )}
        </div>
      </div>
      {allWallets?.length > 0 && (
        <div className="flex justify-between items-center mt-2">
          <div className="opacity-60 text-zinc-100 text-sm font-semibold">
            Showing {indexOfFirstItem + 1}-
            {Math.min(indexOfLastItem, totalCount)} of {totalCount} entries
          </div>
          <div className="flex mt-4 justify-center items-center">
            <div className="justify-start items-center gap-2.5 inline-flex pr-3">
              <div className="text-zinc-100 text-sm font-semibold">
                Items per page
              </div>
              <div className="w-[70px] flex-col justify-start items-start gap-2 inline-flex">
                <div className="relative inline-block text-left">
                  <ReusableMenu
                    buttonIcon={downArrow}
                    isFetching={isFetching}
                    menuItems={[20, 35, 50, "See All"]}
                    buttonText={itemsPerPage}
                    handleChangeFun={handleItemsPerPageChange}
                  />
                </div>
              </div>
            </div>
            <div className="w-[157px] h-[42px] flex-col justify-start items-start gap-[30px] inline-flex">
              <div className="justify-start items-center gap-2 inline-flex">
                <div className="text-zinc-100 text-sm font-semibold">Page</div>
                <div className="w-[70px] flex-col justify-start items-start gap-2 inline-flex">
                  <div className="relative inline-block text-left">
                    <ReusableMenu
                      buttonIcon={downArrow}
                      menuItems={Array.from(
                        {
                          length: Math.ceil(totalCount / itemsPerPage),
                        },
                        (_, i) => i + 1
                      )}
                      buttonText={currentPage}
                      handleChangeFun={paginate}
                      isFetching={isFetching}
                    />
                  </div>
                </div>
                <div className="text-zinc-100 text-sm font-semibold">
                  of {Math.ceil(totalCount / itemsPerPage)}
                </div>
              </div>
            </div>
            <div className="w-[86px] h-[30px] ml-2 relative">
              <div className="w-[86px] h-[30px] p-2 justify-center items-center flex bg-[#1E1E1E] rounded-[27px] border border-[#787878]" />
              <button disabled={isFetching}>
                <img
                  src={rightChev}
                  alt="right"
                  className="w-auto h-[15px] rotate-180 left-[10px] top-[7px] absolute cursor-pointer"
                  onClick={prevPage}
                />
              </button>
              <button disabled={isFetching}>
                <img
                  src={rightChev}
                  alt="left"
                  className="rotate-270 opacity-90 w-auto h-[15px] left-[55px] top-[7px] absolute cursor-pointer"
                  onClick={nextPage}
                />
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ManageWalletsTable;
